<template>
    <div>
        <v-toolbar title elevation="1" color="blue" dark>
            <v-icon left>fas fa-tools</v-icon>
            <v-toolbar-title >Herramientas a solicitar</v-toolbar-title>
            <v-divider vertical class="ml-3"></v-divider>    

            <v-spacer></v-spacer>    
            <v-btn large color="primary" dark rounded class="mx-2 TituloDialogo"  @click="EnviarTodasLasSolicitudes()"
                :loading="loading" :disabled="loading || !ActivarBotonEnviarSolicitud"
            >Enviar Solicitudes
                <v-icon right dark>fas fa-save</v-icon>
            </v-btn>                                       
        </v-toolbar>
        <v-alert :value="alertErrorPost"
                type="error"
                outlined
                transition="scale-transition"
                color="deep-orange">
                <h4>Errores:</h4>
                <ul>
                    <li type="disc" v-for="(i) in arrayErrorPost" :key="i.value">
                        <h6>{{i.description}}</h6>
                    </li>
                </ul>
        </v-alert>        
        <v-data-table
            :headers="EncabezadoTablaSolicitudes"
            :items="ArrayTodasLasSolicitudesAEnviar"
            item-key="idHerramienta"
            class="elevation-1"
            :footer-props="{itemsPerPageText: 'Filas por página'}"                 
        >
            <template v-slot:item.action="{ item }">
                <v-tooltip bottom color="#D80000">
                    <template v-slot:activator="{ on }">
                        <v-btn  small class="ml-2" dark fab color="#D80000" v-on="on" @click="QuitarSolicitudMateriales(item)">
                            <v-icon small>fas fa-trash-alt</v-icon>
                        </v-btn>                        
                    </template>
                    <span class="fontButton">Quitar Solicitud de Herramienta</span>
                </v-tooltip>                                              
            </template>        
            <template v-slot:no-data v-if="ArrayTodasLasSolicitudesAEnviar.length === 0">
                <v-alert dense outlined class="text-xs-center textoalerta" type="warning" prominent border="left" >
                    No existen solicitudes de Herramientas a enviar
                </v-alert>
            </template>                    
        </v-data-table>        
    </div>
</template>

<script>
import { showMessageSuccess, showMessageError } from '../../../services/sweetAlert'

export default {
    props:{
        ArrayTodasLasSolicitudesAEnviar: Array,
        proyecto: Number,
        sucursal:Number,
        bodega:Number,
    },

    components:{

    },

    data() {
        return {
            loading: false,
            EncabezadoTablaSolicitudes:[
                {text: 'Tipo Herramienta', value: 'tipoHerramienta', sortable: false, align: 'center', divider: 'true', class: 'TamañoLetraBoton'},
                {text: 'Nombre', value:'nombreHerramienta', sortable: false, align:'center', divider: 'true', class: 'TamañoLetraBoton'},
                {text: 'Marca', value: 'marcaHerramienta', sortable: false, align: 'center', divider: 'true', class: 'TamañoLetraBoton'},
                {text: 'Cantidad Solicitar', width:'300px', value: 'cantidadSolicitada', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Acciones', value: 'action', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],
            ActivarBotonEnviarSolicitud:false,
            // errores registros duplicados y vacíos
            alertErrorPost:false,
            arrayErrorPost:[],                        
        }
    },
    watch:{
        ArrayTodasLasSolicitudesAEnviar(){
            if(this.ArrayTodasLasSolicitudesAEnviar.length >0){
                this.ActivarBotonEnviarSolicitud = true
            }else{
                this.ActivarBotonEnviarSolicitud = false
            }
        },        
        sucursal(){
            // this.$emit('ObtenerTodasLasHerramientas')
            this.alertErrorPost=false
            this.arrayErrorPost=[]            
        },
    },

    methods: {
        async EnviarTodasLasSolicitudes(){
            this.loading = true
            this.alertErrorPost=false;this.arrayErrorPost=[]; 
            var data = {soli: this.ArrayTodasLasSolicitudesAEnviar, Proyecto: this.proyecto, Sucursal: this.sucursal, Bodega: this.bodega} 
            const response = await this.$store.dispatch('EnviarSolicitudesDeHerramientasABodega', data)
            if(response.status === 200){
                this.alertErrorPost=false;this.arrayErrorPost=[]; 
                this.loading = false
                this.alertError= false
                showMessageSuccess('¡BIEN!', response.data.message)
                this.$emit('ObtenerTodasLasHerramientas')
            }else{
                this.ControlladorExcepciones(response)
            }            
        },
        ControlladorExcepciones(response){
            if(typeof response === 'undefined'){
                this.ControllerException()
                this.alertErrorPost = false
                return 0
            }else if(response.status === 400){
                this.alertErrorPost=true
                var object = response.data.errors
                for (var property in object){
                    this.arrayErrorPost.push({description: `${object[property]}`})
                }
                this.loading = false
            }else if(response.status === 401){
                showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')
                this.loading = false       
                this.alertErrorPost = false
            }else if(response.status === 404){
                showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                this.loading = false
                this.alertErrorPost = false
            }else if(response.status === 500){
                showMessageError('Error 500','Error en el servidor')            
                this.loading = false
                this.alertErrorPost = false
            }                
        },
        QuitarSolicitudMateriales(item){
            const index =this.ArrayTodasLasSolicitudesAEnviar.indexOf(item)
            this.ArrayTodasLasSolicitudesAEnviar.splice(index,1)
        },                        
    },
}
</script>